<template>
    <div id="account_detail">
        <!-- <div class="top_title fixed">账务明细</div> -->
        <bill-item2 :list="list" v-if="list.length > 0 && show"/>
        <div class="end" v-if="list.length > 0 && show">资金流水记录结束</div>
        <div class="end" v-else-if="list.length == 0 && show">
            暂无资金流水记录
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show: false,
                list: []
            };
        },
        mounted() {
            this.getBillList();
        },
        methods: {
            addDate(list) {
                const groupedArray = list.reduce((acc, curr) => {
                    // 将 "ctime" 字段转换为日期对象
                    const date = curr.ctime.substring(0, 10);
                    // 搜索已有的分组中是否有与当前日期相同的分组，
                    // 如果有则将当前数据加入该分组，
                    // 如果没有则新建一个分组并加入当前数据
                    const existingGroup = acc.find(
                        (group) => group.date == date
                    );
                    if (existingGroup) {
                        existingGroup.data.push(curr);
                    } else {
                        acc.push({
                            date: date,
                            weekDay: new Date(date).getDay(),
                            data: [curr],
                        });
                    }
                    return acc;
                }, []);
                return groupedArray;
            },
            getBillList() {
                this.$Ajax('wallet/margin-bill',{},'get').then(rs => {
                    this.show = true
                    if(rs.code == 200) {
                        this.list = this.addDate(rs.data)
                    }
                })
            }
        },
    };
</script>
<style lang="less" scoped>
.end {
    text-align: center;
    margin: 2rem 0;
    color: #aaa;
}
#account_detail {
    padding-top: 1rem;
}
</style>